export const submitPost = (url: string, params: Record<string, string>): void => {
  const form = document.createElement('form');
  form.setAttribute('method', 'POST');
  form.setAttribute('action', url);

  Object.keys(params).forEach((key) => {
    const hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  });

  const rootElement = document.getElementById('root') || document.body;
  rootElement.appendChild(form);

  // Use prototype method to bypass potential shadowing issues
  // This prevents "Method not found" errors when form elements might interfere
  try {
    HTMLFormElement.prototype.submit.call(form);
  } catch (error) {
    // Fallback: Create and click a submit button
    // This works even when direct submit() calls are blocked
    const submitButton = document.createElement('input');
    submitButton.setAttribute('type', 'submit');
    submitButton.style.display = 'none';
    form.appendChild(submitButton);
    submitButton.click();
  }
};
